import { profileLocationSchema } from "@wags/profile-contracts/profile.contract.ts";
import { z } from "zod";

const LatitudeSchema = z.number().finite().min(-90).max(90);
const LongitudeSchema = z.number().finite().min(-180).max(180);
const IpApiLatitudeSchema = z.preprocess(
    (value) =>
        typeof value === "string" && value.trim() !== ""
            ? Number(value)
            : value,
    LatitudeSchema,
);
const IpApiLongitudeSchema = z.preprocess(
    (value) =>
        typeof value === "string" && value.trim() !== ""
            ? Number(value)
            : value,
    LongitudeSchema,
);

export const CallerIpSchema = z.union([z.ipv4(), z.ipv6()]);

export const ViewerLocationSchema = profileLocationSchema
    .required({
        lat: true,
        lng: true,
    })
    .extend({
        lat: LatitudeSchema,
        lng: LongitudeSchema,
    })
    .transform(({ city, state, lat, lng, radius }) => ({
        ...(city === undefined ? {} : { city }),
        ...(state === undefined ? {} : { state }),
        lat,
        lng,
        ...(radius === undefined ? {} : { radius }),
    }));

export type ViewerLocation = z.infer<typeof ViewerLocationSchema>;

export const LocationEstimateResponseSchema = z.object({
    latitude: LatitudeSchema,
    longitude: LongitudeSchema,
    city: z.string().optional(),
    region: z.string().optional(),
    regionCode: z.string().optional(),
    country: z.string().optional(),
    countryName: z.string().optional(),
    postal: z.string().optional(),
    source: z.enum(["vercel", "ipapi"]),
});

export type LocationEstimateResponse = z.infer<
    typeof LocationEstimateResponseSchema
>;

export const LocationEstimateErrorSchema = z.object({
    error: z.literal(true),
    reason: z.string(),
});

export const IpApiResponseSchema = z.object({
    latitude: IpApiLatitudeSchema.optional(),
    longitude: IpApiLongitudeSchema.optional(),
    city: z.string().optional(),
    region: z.string().optional(),
    region_code: z.string().optional(),
    country: z.string().optional(),
    country_code: z.string().optional(),
    country_name: z.string().optional(),
    postal: z.string().optional(),
    error: z.boolean().optional(),
    reason: z.string().optional(),
});

export const VercelGeoHeadersSchema = z.object({
    latitude: IpApiLatitudeSchema,
    longitude: IpApiLongitudeSchema,
    city: z.string().optional(),
    country: z.string().optional(),
    countryRegion: z.string().optional(),
    postalCode: z.string().optional(),
});

export type VercelGeoLocation = z.infer<typeof VercelGeoHeadersSchema>;
